import Dashboard from './dashboard';
import Monitor from './monitor';
import Schedule from './schedule';
import OpOs from './opos';

export default {
  Dashboard,
  Monitor,
  Schedule,
  OpOs,
};
